var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"recipe-label",attrs:{"color":"secondary darken-1","text-color":"accent","small":""}},[_c('v-avatar',{staticClass:"secondary darken-2 white--text"},[_c('v-icon',{attrs:{"small":""}},[_vm._v(_vm._s(_vm.icon))])],1),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.value))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }